import RTableLayout from "../../../layout/RTableLayout";
import {CMargin, DText, Flex, Row} from "../../../../../styles/CommonStyles";
import Text from "../../../../../core/utils/Text";
import CoinRow from "../../../../common/common/CoinRow";
import UserTag from "../../../../common/utils/UserTag";
import {TradeTypeBadge} from "../../../../../styles/main/orders";
import {LineBreak} from "../../../../../styles/main/MainCommonStyles";
import {formatDate} from "../../../../../core/utils/common";
import {useMainContext} from "../../../../../core/contexts/main";
import {CopyIcon} from "../../../../../styles/main/reports";
import {useCopyToClipboard} from "../../../../../core/hooks/common/useCopyToClipboard";
import Operation from "../../../../common/utils/Operation";
import {useNavigate} from "react-router-dom";


const RContractTable = ({ data, business }) => {

    const { lang } = useMainContext()
    const { data: contracts } = data
    const { copyToClip } = useCopyToClipboard()
    const navigate = useNavigate()
    const onDetailsClicked = (p) => {
        navigate(`/reports/wallet-transactions/${p._id}`)
    }

    return (
        <RTableLayout
            data={data}
        >
            {contracts?.data?.map((item, idx) => (
                <Row key={item._id} index={idx} cs={'100%'}>
                    <div style={{ position: 'absolute', left: 0, top: '-42px' }}>
                        <Operation
                            onDetailsClicked={() => onDetailsClicked(item)}
                            hasDetails
                        />
                    </div>
                    {!business ?
                        <UserTag user={item.user} idx={idx} />
                        :null}
                    <CMargin margin={'2px'} />
                    <Flex fw justify={'flex-start'}>
                        <DText fontSize={'ss'} main style={{width: '42px'}}>
                            <Text tid={'address'} /> :
                        </DText>
                        <DText fontSize={'ss'} primary margin={'0 5px'} style={{ lineBreak: 'anywhere', width: 'calc(100% - 42px)' }} >
                            {item.address}
                        </DText>
                        <CopyIcon size={18} onClick={() => copyToClip(item.address)} />
                    </Flex>
                    <LineBreak />
                    <Flex justify={'space-between'}>
                        <DText fontSize={'ss'} main>
                            <Text tid={'currency'} /> :
                        </DText>
                        <CoinRow coin={{ currency: item.currency }} />
                    </Flex>
                    <LineBreak />
                    <Flex justify={'space-between'}>
                        <DText fontSize={'ss'} main>
                            <Text tid={'amount'} /> :
                        </DText>
                        <DText fontSize={'ss'} primary>
                            {item.amount}
                        </DText>
                    </Flex>
                    <LineBreak />
                    <Flex justify={'space-between'}>
                        <DText fontSize={'ss'} main>
                            <Text tid={'network'} /> :
                        </DText>
                        <TradeTypeBadge>
                            {item.network}
                        </TradeTypeBadge>
                    </Flex>
                    <LineBreak />
                    <Flex justify={'space-between'}>
                        <DText fontSize={'ss'} main>
                            <Text tid={'type'} /> :
                        </DText>
                        <TradeTypeBadge>
                            <Text tid={item.flow} />
                        </TradeTypeBadge>
                    </Flex>
                    <LineBreak />
                    <Flex justify={'space-between'}>
                        <DText fontSize={'ss'} main>
                            {formatDate(item.createdAt, 'date', lang)}
                        </DText>
                        <DText fontSize={'ss'} main>
                            {formatDate(item.createdAt, 'time', lang)}
                        </DText>
                    </Flex>
                </Row>
            ))}
        </RTableLayout>
    )
}

export default RContractTable
